// @flow
import React from 'react';
import './PaginatedScrollerSkeleton.css';

const PaginatedScrollerSkeleton = () => (
  <div className="paginated-scroller-main">
    <div className="paginated-scroller-skeleton-header">
      <div className="paginated-scroller-skeleton-header-line paginated-scroller-skeleton-header-line--short skeleton-block" />
      <div className="paginated-scroller-skeleton-header-title skeleton-block" />
      <div className="paginated-scroller-skeleton-header-line paginated-scroller-skeleton-header-line--long skeleton-block" />
    </div>
    <div className="paginated-scroller-skeleton-cards">
      {[0, 1, 2, 3, 4, 5].map(i => (
        <div key={i} className="paginated-scroller-skeleton-card">
          <div className="paginated-scroller-skeleton-card-img skeleton-block" />
        </div>
      ))}
    </div>
    <div className="paginated-scroller-skeleton-mobile">
      {[0, 1, 2, 3].map(i => (
        <div key={i} className="paginated-scroller-skeleton-card-mobile">
          <div className="paginated-scroller-skeleton-card-mobile-img skeleton-block" />
        </div>
      ))}
    </div>
  </div>
);

export default PaginatedScrollerSkeleton;
